export default __webpack_public_path__ + "static/media/Frame 187gray.3f75f200.svg";